import { Pipe, PipeTransform } from '@angular/core';
import workingStatus from '../../../assets/working-status.json';
import { IWorkingStatus } from 'src/app/models/map.js';

@Pipe({
  name: 'workingstatuspipe'
})
export class WorkingstatusimagePipe implements PipeTransform {
  workingStatus: IWorkingStatus[] = workingStatus;
  transform(value: number, ...args: unknown[]): unknown {
    return this.workingStatus.filter(x => x.id === value)[0].image;
  }

}
